<template>
  <CreateEditBoardModal
    v-if="showCreateEditBoardModal"
    :boardId="boardIdSelected"
    @closeModal="closeModal"
  />
  <DeleteBoardModal
    v-if="showDeleteBoardModal"
    :boardId="boardIdSelected"
    @closeModal="closeModal"
  />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Quadros</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Cadastre os quadros do Ninja dos quais deseja obter os tickets
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Cadastrar Quadro"
          @click="createEditBoard()"
        >
          Cadastrar Quadro
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListBoards
      v-else
      :boards="boards"
      @createEditBoard="createEditBoard"
      @deleteBoard="deleteBoard"
    />
  </div>
</template>

<script>
import CreateEditBoardModal from '@/components/params/boards/CreateEditBoardModal.vue'
import DeleteBoardModal from '@/components/params/boards/DeleteBoardModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListBoards from '@/components/params/boards/ListBoards.vue'

export default {
  name: 'Boards',

  components: {
    CreateEditBoardModal,
    DeleteBoardModal,
    LoadingData,
    ListBoards,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateEditBoardModal: false,
      showDeleteBoardModal: false,
      boards: [],
      boardIdSelected: null,
    }
  },

  methods: {
    async getBoards() {
      try {
        this.boards = await this.$store.dispatch('getBoards')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditBoard(boardId) {
      this.boardIdSelected = boardId || null
      this.showCreateEditBoardModal = true
    },

    deleteBoard(boardId) {
      this.boardIdSelected = boardId
      this.showDeleteBoardModal = true
    },

    closeModal(needReload) {
      if (needReload) {
        this.getBoards()
      }
      this.showCreateEditBoardModal = false
      this.showDeleteBoardModal = false
    },
  },

  mounted() {
    this.getBoards()
  },
}
</script>
